import $store from '@/store'
import NameUtil from '@/utils/NameUtil'
import StoreDefineUser from '@/define/store/user/user'
import DashboardServiceInfo from '@/model/user/DashboardServiceInfo'
import DashboardModuleInfo from '@/model/user/DashboardModuleInfo'
import StorageKeyDefineLogin from '@/define/storage/login'
import UserInfo from '@/model/modules/UserInfo'

export default class UserService {
  public static getDashBoardBaseInfo(): Promise<DashboardServiceInfo[]> {
    return new Promise<DashboardServiceInfo[]>((resolve, reject) => {
      const dashboardModules: DashboardServiceInfo[] = []
      const orderServiceModule = new DashboardServiceInfo('个人中心', 'order')
      orderServiceModule.dashBoardModules.push(new DashboardModuleInfo('我的订单', 'mdi-newspaper-variant-multiple', 'order-manage'))
      orderServiceModule.dashBoardModules.push(new DashboardModuleInfo('资金日志', 'mdi-currency-usd-circle-outline', 'bill-log'))
      dashboardModules.push(orderServiceModule)
      const group = sessionStorage[StorageKeyDefineLogin.LOGIN_USER_GROUP]
      if (group === 'admin') {
        const adminServiceModule = new DashboardServiceInfo('管理中心', 'admin')
        adminServiceModule.dashBoardModules.push(new DashboardModuleInfo('用户组管理', 'mdi-account-multiple', 'user-group-manage'))
        adminServiceModule.dashBoardModules.push(new DashboardModuleInfo('用户管理', 'mdi-account-box-multiple', 'user-manage'))
        adminServiceModule.dashBoardModules.push(new DashboardModuleInfo('发件人管理', 'mdi-account-tie-voice', 'from-user-manage'))
        adminServiceModule.dashBoardModules.push(new DashboardModuleInfo('物流方式管理', 'mdi-car-connected', 'courier-manage'))
        dashboardModules.push(adminServiceModule)
      }
      $store.commit(NameUtil.CSCK(StoreDefineUser.SET_DASHBOARD_MODULES), dashboardModules)
      resolve(dashboardModules)
    })
  }

  public static setSelectedDashboardModule(selectedDashboardModule: DashboardModuleInfo) {
    $store.commit(NameUtil.CSCK(StoreDefineUser.SET_SELECTED_DASHBOARD_MODEL), selectedDashboardModule)
  }

  public static getSelectedDashboardModule(): DashboardServiceInfo {
    return $store.getters[NameUtil.CSCK(StoreDefineUser.GET_SELECTED_DASHBOARD_MODEL)]
  }
}
